// extracted by mini-css-extract-plugin
export var copyableField = "_ki-4";
export var customerBadge = "_ki-0";
export var customerInfoTitle = "_ki-2";
export var details = "_ki-1";
export var dropdownContainer = "_ki-5";
export var dropdownImage = "_ki-6";
export var editAssigneeForm = "_ki-a";
export var editButton = "_ki-3";
export var email = "_ki-7";
export var hidden = "_ki-d";
export var input = "_ki-8";
export var saveButton = "_ki-b";
export var shopifyIcon = "_ki-c";
export var suggestionBadge = "_ki-e";
export var suggestionText = "_ki-f";
export var username = "_ki-9";